(function () {

var MIN_DELAY_MS = 6000;
var ABSOLUTE_TIMEOUT_MS = 6000;

function cloneScript(original) {
    var s = document.createElement('script');
    s.type = 'text/javascript';

    var src = original.getAttribute('data-src') || original.getAttribute('src') || original.getAttribute('data-rocket-src') || '';
    if (src) s.src = src;

    if (original.defer) s.defer = true;

    ['nonce', 'crossorigin', 'referrerpolicy', 'integrity', 'id'].forEach(function (attr) {
    var v = original.getAttribute(attr);
    if (v) s.setAttribute(attr, v);
    });

    Array.prototype.forEach.call(original.attributes, function (a) {
    if (/^data-/.test(a.name) &&
        !/^(data-type|data-src|data-consent|data-lazy|nitro-delay-ms)$/i.test(a.name)) {
        s.setAttribute(a.name, a.value);
    }
    });

    if (!src && original.textContent) s.text = original.textContent;
    return s;
}

function activateNext(list, index, done) {
    if (index >= list.length) {
    if (typeof done === 'function') done();
    return;
    }
    var el = list[index];
    if (!el || !el.parentNode) {
    activateNext(list, index + 1, done);
    return;
    }
    var s = cloneScript(el);
    var parent = el.parentNode || document.head || document.documentElement;
    parent.insertBefore(s, el);
    el.remove();

    var src = s.getAttribute('src');
    if (src) {
    s.onload = s.onerror = function () { activateNext(list, index + 1, done); };
    } else {
    activateNext(list, index + 1, done);
    }
}

function runNow() {
    var nodes = document.querySelectorAll('script[data-rocket-type]');
    var list = Array.prototype.slice.call(nodes);
    if (list.length === 0) {
    finish();
    return;
    }
    activateNext(list, 0, finish);
}

function finish() {
    try {
    window.dispatchEvent(new CustomEvent('nitro-delay-done'));
    } catch (e) {}
}

var events = ['scroll', 'mousemove', 'touchstart', 'keydown', 'wheel', 'click'];
function addListeners() {
    events.forEach(function (ev) {
    window.addEventListener(ev, runNow, { passive: true, once: true });
    });
    window.addEventListener('load', function () { setTimeout(runNow, MIN_DELAY_MS); }, { once: true });
}

addListeners();
setTimeout(runNow, ABSOLUTE_TIMEOUT_MS);

window.NitroLazyLoadDelay = { runNow: runNow };
})();
  